function initMobileMenu()
{
    var btn = $('#menu-button');
    var menu = $('#menu');
    
    var updateIcon = function () {
        btn.find('i').text(menu.hasClass('open') ? 'close' : 'menu');
    };
    
    btn.click(function (e) {
        e.preventDefault();
        menu.toggleClass('open');
        updateIcon();
    });
    
    $('body').click(function (e) {
        
        if (btn.is(e.target) || menu.is(e.target)) {
            return;
        }
        
        menu.removeClass('open');
        updateIcon();
    });
}

$(document).ready(function () {
    
    initMobileMenu();
    
});
